import { render } from "./chat-item.vue?vue&type=template&id=7af1a86c&scoped=true"
import script from "./chat-item.vue?vue&type=script&lang=js"
export * from "./chat-item.vue?vue&type=script&lang=js"

import "./chat-item.vue?vue&type=style&index=0&id=7af1a86c&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af1a86c"]])

export default __exports__